var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'user-photo-list',
  created () {
    var readMore = false
    if (this.currentPage !== null && this.currentPage >= 1) {
      readMore = 'keepload'
    }

    utils.backClear()

    this.shopGet()
    this.usertypeGet()

    var ssShopIds = window.sessionStorage.getItem("shopIds")
    var ssUserName = window.sessionStorage.getItem("userName")
    var ssUserTypeIds = window.sessionStorage.getItem("userTypeIds")

    if (ssShopIds == null || ssShopIds.length == 0) {
      if ((this.isSystemManagement || this.isAppIncluding) && (window.sessionStorage.getItem('shopNull') == 'on')) {
        this.shopIds = []
      } else {
        this.shopIds = window.localStorage.getItem("shop_id").split(",")
      }
    } else {
      this.shopIds = ssShopIds.split(",")
      if (this.shopIds.length == 1 && this.shopIds[0] == 800) {
        this.shopIds = window.localStorage.getItem("shop_id").split(",")
      } else {
        //退職者一覧店舗を表示しない
        var workIndex = 0
        for (var i=0; i < this.shopIds.length; i++) {
          if (this.shopIds[i] == 800) {
            workIndex = i
            break;
          }
        }
        if (workIndex != 0) {
          this.shopIds.splice(workIndex,1)
        }
      }
    }
    if (ssUserName !== null) {
      this.userName = ssUserName
    }
    if (ssUserTypeIds == null || ssUserTypeIds.length == 0) {
    } else {
      this.usertypeIds = ssUserTypeIds.split(",")
    }

    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      shopName: '',
      userName: '',
      usertypeName: '',
      shopGetCallbackFlag: false,
      usertypeGetCallbackFlag: false,
      searchCallbackFlag: false,
      shopIds: [],
      usertypeIds: [],
      searchTotalCount: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    users () {
      return this.$store.getters.users
    },
    shops () {
      return this.$store.getters.shopsAll
    },
    usertypes () {
      return this.$store.getters.usertypesAll
    },
    nextPage () {
      return this.$store.getters.usersNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    currentPage () {
      return this.$store.getters.usersCurrentPage
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isAppIncluding () {
      return this.$store.getters.isAppIncluding
    },
    isAppNotIncluded () {
      return this.$store.getters.isAppNotIncluded
    },
    isBrowsIncluding () {
      return this.$store.getters.isBrowsIncluding
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      if (this.shopIds.length !== 0) {
        window.sessionStorage.setItem('shopIds', this.shopIds)
      } else {
        window.sessionStorage.setItem('shopNull', 'on')
        window.sessionStorage.removeItem('shopIds')
      }
      if (this.userName !== null) {
        window.sessionStorage.setItem('userName', this.userName)
      } else {
        window.sessionStorage.removeItem('userName')
      }
      if (this.usertypeIds !== '') {
        window.sessionStorage.setItem('userTypeIds', this.usertypeIds)
      }

      var url = null
      if (readMore) {
        url = this.$store.getters.usersNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function (totalCount) {
        self.searchTotalCount = totalCount
        self.searchCallbackFlag = true
      }
      var data = {
        'shop_ids': this.shopIds,
        'user_name': this.userName,
        'user_type_ids': this.usertypeIds,
        'shop_id' : ""
      }

      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      this.$store.dispatch('USER_LIST_SEARCH', {url: url, data: data, callback: callback})
    },
    shopGet: function() {
      var self = this
      var callback = function (){
        self.shopGetCallbackFlag = true
        //退職者一覧店舗を表示しない
        var workIndex = 0
        for (var i=0; i < self.shops.length; i++) {
          if (self.shops[i].id == 800) {
            workIndex = i
            break;
          }
        }
        if (workIndex != 0) {
          self.shops.splice(workIndex,1)
        }
      }

      this.$store.dispatch('SHOP_ALL_GET', {callback: callback})
    },
    usertypeGet: function() {
      var self = this
      var callback = function (){
        self.usertypeGetCallbackFlag = true
      }
      this.$store.dispatch('USERTYPE_ALL_GET', {callback: callback})
    },
    goUserLists: function () {
      utils.backClear()
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goShopLists: function () {
      utils.backClear()
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    goChangeLists: function () {
      utils.backClear()
      this.$router.push({ path: '/userchanges', query: { type: this.$router.currentRoute.query.type}})
    },
    goRitireeLists: function() {
      utils.backClear()
      this.$router.push({ path: '/retiree', query: { type: this.$router.currentRoute.query.type}})
    },
    half: function () {
      this.userName = utils.emHalf(this.userName)
    },
    /** 写真一覧印刷 */
    printUserPhotoInfoPdf: function () {
      var data = {
        'shop_ids': this.shopIds,
        'user_name': this.userName,
        'user_type_ids': this.usertypeIds
      }

      var callback = function (ret) {
        let protocol = window.location.protocol
        let url = protocol + '//' + ret.url
        let form = document.getElementById("pdf_photo_download")
        form.action = url
        document.getElementById('token').value = window.localStorage.getItem('access_token')
        document.getElementById('download_id').value = ret.download_id;

        form.submit()
      }
      this.$store.dispatch('USER_PHOTO_PDF', { data: data, callback: callback })
    },

    /** 画像押下 */
    onClickImageModalShow: function (user) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = user.attributes['avartar-path'] + '?token=' + this.authToken + "&timestamp=" + self.timeStamp
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/user-photo-list.js